import _ from 'lodash'
import moment from 'moment'

export const getScanSatus = (scanStatus) => {
    switch (scanStatus) {
        case 0:
            return 'scanned';
        case 1:
            return 'transferred_before_scan';
        case 2:
            return 'awaiting_return';
        case 6:
            return 'returned';
        default:
            return scanStatus;
    }
}

export function regexZipMatch(zip, userUS) {
    const POSTAL_CODE_REGEX_US = /^\d{5}(?:[-\s]\d{4})?$/i;
    const POSTAL_CODE_REGEX_CA = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/i;

    const regex = userUS ? POSTAL_CODE_REGEX_US : POSTAL_CODE_REGEX_CA;

    return regex.test(zip);
}

export function handleCapitalize(data) {
    if (typeof data === 'string') {
        return data.toUpperCase();
    } else if (Array.isArray(data)) {
        return data.map((value) => value.toUpperCase())
    } else {
        return data;
    }
}

export function latLngVerify(obj) {
    if(obj.lat) {
        const latRegex = /^[+-]?(([1-8]?[0-9])(\.[0-9]+)?|90(\.0+)?)$/i;
        return latRegex.test(obj.lat);
    } else if(obj.lng) {
        const lngRegex = /^[+-]?((([1-9]?[0-9]|1[0-7][0-9])(\.[0-9]+)?)|180(\.0+)?)$/i;
        return lngRegex.test(obj.lng);
    }
    return true;
}

export function getChildBranchList(parentBranchId, branchList) {
    return _.filter(branchList, (branch)=>{return branch.parent === parentBranchId && branch.id !== parentBranchId})
}

export function handleTextualizeDriverNameAndVehicleType(input, userCity, driverListTemp, searchList) {
    let name = '...';
    if(input + '' === '0') {
        name = '0.Unknown';
    } else if((userCity === 2 || userCity === 14) && driverListTemp) {
        driverListTemp.map((staff) => {
            if(input + '' === staff.id + '' && staff.is_hired !== 0) {
                let vehicleType = staff?.vehicle_type ? staff?.vehicle_type : 'No data';
                name = staff.name + ' -- Vehicle type: ' + vehicleType;
                return;
            }
        })
    }
    searchList.map((staff) => {
        if(input + '' === staff.id + '' && staff.is_hired !== 0) {
            let vehicleType = staff?.vehicle_type ? staff?.vehicle_type : 'No data';
            name = staff.name + ' -- Vehicle type: ' + vehicleType;
            return;
        }
    })
    return name;
}

export function textualizationStatus(status){
    if(status) {
        return 'YES';
    } else {
        return 'NO';
    }
}

export function stripIdFromStaffName(name){
    if(name) {
        return name.replace(/^\d*\./, "")
    }
    return '';
}

export function getDistrictName(id){
    let localStorage = window.localStorage
    let districts = JSON.parse(localStorage.getItem('districts'))
    return districts[id] || "Unknown"
}

export function getAccountFilteredDistricts(accounts){
    let district = {}
    _.map(accounts, function(account){
        if (!district.hasOwnProperty(account.district)){
            district[account.district] = []
        }
        district[account.district].push(account)
    })
    return district
}

export function splitOrderByDistrict(orders){
    let result = {}
    _.map(orders, function(order){
        if (!result.hasOwnProperty(order.district)){
            result[order.district] = []
        }
        result[order.district].push(order)
    })

    return result
}

export function setUserPreference(authToken, userLevel, userCity, username, id){
    let localStorage = window.localStorage;
    localStorage.setItem('auth_token', authToken)
    localStorage.setItem('user_level', userLevel)
    localStorage.setItem('user_city', userCity)
    localStorage.setItem('username', username)
    localStorage.setItem('user_id', id)
}

export function getUserPreference(){
    let localStorage = window.localStorage;
    return {
        authToken: localStorage.getItem('auth_token'),
        userLevel: localStorage.getItem('user_level'),
        userCity: JSON.parse(localStorage.getItem('user_city')),
        userId: localStorage.getItem('user_id'),
        username: localStorage.getItem('username'),
        selectBatchCountFilter: localStorage.getItem('select_batch_count_filter'),
        autoLatLng: JSON.parse(localStorage.getItem('auto_lat_lng') || true),
        hideAssociatedOrders: JSON.parse(localStorage.getItem('hide_associated_orders') || true),
        hideSubReferrer: JSON.parse(localStorage.getItem('hide_sub_referrer') || false)
    }
}

export function setAutoLatLngPref(set){
    let localStorage = window.localStorage;
    localStorage.setItem('auto_lat_lng', JSON.stringify(set))
}

export function setHideAssociatedOrders(set){
    let localStorage = window.localStorage;
    localStorage.setItem('hide_associated_orders', JSON.stringify(set))
}

export function setHideSubReferrer(set){
    window.localStorage.setItem('hide_sub_referrer', JSON.stringify(set))
}

export function getDriverOrderTrackingStatus(districtOrders = {}){
    let codes = _.map(districtOrders, (districtOrder) => {
        let _code = _.map(districtOrder, 'path_info')
        return _code
    })
    return _.uniq(_.flatten(codes))
}

export function getBranchById(id, branchList = []){
    if(!id) {
        return;
    }
    if(branchList.length <= 0){
        branchList = JSON.parse(window.localStorage.getItem('branches'))
    }
    return _.find(branchList, {'id': Number(id)});
}

export function getCurrentWarehouse(){
    let cityId = window.localStorage.getItem("user_city");

    return getBranchById(cityId)
}

export function getRefererFromId(batches, ids){
    let result = batches.filter(batch => ids.includes(batch.id)).map(batch => batch.referer)
    return result
}

export function getCheckedOrders(orderList, selectedIds){
    let orders = []
    _.map(orderList, (order, key)=>{
        let flatten = _.intersectionWith(_.flatten(_.values(order)), selectedIds, function(o, id){ return o.order_id === id})
        orders = _.union(orders, flatten)
    })
    return orders
}

export function getImageDimensions(uri){
    return new Promise((resolve, reject) => {
        let i = new Image()
        i.onload = () => {
            resolve({width: i.width, height: i.height, src: uri})
        }
        i.onerror = (error) => {
            reject(error)
        }
        i.src = uri
    })
}

export function DataURIToBlob(dataURI) {
    const splitDataURI = dataURI.split(',')
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

    const ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++)
        ia[i] = byteString.charCodeAt(i)

    return new Blob([ia], { type: mimeString })
  }

export function flattenOrders(orders = []){
    let result = []
    _.forEach(orders, (element)=>{
        let array = _.values(element).reduce((o, m) => [...o, ...m], [])
        result.push(...array)
    })
    return result
}

export const delay = ms => new Promise(res => setTimeout(res, ms));

export const getRoutePrefix = (accountName) => {
    return `${moment().format('MMDD')}.${accountName}`
}

export const formatTimestamp = (timestamp, format) => {
    return moment.unix(timestamp).format(format)
}

export const getUserById = (id, list = []) => {
    return _.find(list, {'id': Number(id)})
}

export const getShien = (isShein) => {
    if(isShein === 1){
        return "Yes"
    }else{
        return "No"
    }
}

/**
 * Parse JWT token to provide user data
 * @param {string} token - Token from server
 */
export const parseJwt = (token) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(Buffer.from(base64, 'base64').toString().split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
};

/**
 * Convenience method that trims and join strings together 
 * @param {string} joinedBy - String separator
 * @param {...string} strings - Rest param for all the strings wanted to be joined
 */
export const concatStrings = (joinedBy, ...strings) => {
    let trimmedArray = _.compact(strings)
    return _.join(trimmedArray, joinedBy)
}

export const isJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch(e) {
        return false;
    }
    return true;
}